const Video = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7.5A2.5 2.5 0 0 1 7 5h9a2.5 2.5 0 0 1 2.5 2.5v9A2.5 2.5 0 0 1 16 19H7a2.5 2.5 0 0 1-2.5-2.5zM7 6a1.5 1.5 0 0 0-1.5 1.5v9A1.5 1.5 0 0 0 7 18h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 16 6z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m18 12 1.83-2.44c.375-.5 1.17-.235 1.17.39v4.1c0 .625-.795.89-1.17.39z"
    />
  </>
)
export default Video
